<template>
  <v-container fluid>
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar
              flat
          >
            <v-btn
                outlined
                small
                color="grey darken-2"
                class="ml-n3"
                @click="setToday"
            >
              Today
            </v-btn>
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title class="small">
              {{ title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <TimeTrackerNewDialogTime  :user-id="userId" event="working"></TimeTrackerNewDialogTime>
            <TimeTrackerNewDialogTime  :user-id="userId" event="work_kug"></TimeTrackerNewDialogTime>
            <TimeTrackerNewDialogTime  :user-id="userId" event="time_correction"></TimeTrackerNewDialogTime>
            <TimeTrackerNewDialogTime  :user-id="userId" event="time_add"></TimeTrackerNewDialogTime>
            <TimeTrackerNewDialogRange :user-id="userId" event="holiday"></TimeTrackerNewDialogRange>
            <TimeTrackerNewDialogRange :user-id="userId" event="holiday_extra"></TimeTrackerNewDialogRange>
            <TimeTrackerNewDialogRange :user-id="userId" event="sick"></TimeTrackerNewDialogRange>
            <TimeTrackerNewDialogRange :user-id="userId" event="sick_with_child"></TimeTrackerNewDialogRange>
            <TimeTrackerNewDialogRange :user-id="userId" event="sick_kug"></TimeTrackerNewDialogRange>
          </v-toolbar>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            top
          >
          </v-progress-linear>
        </v-sheet>
        <v-sheet
            :height="$vuetify.breakpoint.height * 0.9 - 200"
        >
          <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              type="month"
              :weekdays="weekdays"
              @change="onUpdateFilters"
              @click:date="clickOnDate"
          >
            <template v-slot:day="data">
              <v-card
                  height="100%"
                  class="align-center justify-center"
                  :color="getDateColor(data.date)"
                  tile
              >
                <v-card-text
                    v-if="getDateEvents[data.date] !== undefined"
                >
                    <v-chip
                        dark
                        color="blue"
                        v-if="getDateEvents[data.date].work != 0 || getDateEvents[data.date].pause != 0"
                        class="mt-n7 py-5 px-1 mx-1"
                    >
                      <span class="text-caption">
                        {{ getDuration(getDateEvents[data.date].work) }}
                        <br/>
                        {{ getDuration(getDateEvents[data.date].pause) }}
                      </span>
                    </v-chip>
                    <span
                        v-for="(event_name, index) in getDateEvents[data.date].events"
                        :class=getEventClass(event_name)
                    >
                      {{ getEventClassName(event_name) }}
                    </span>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:event="event">
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

    <v-dialog
        ref="dialog"
        v-model="dialog"
        :max-width="$vuetify.breakpoint.width * 0.8"
    >
      <v-card>
        <TimeTrackerEvent
            :userId="userId"
            :deleted-init="true"
            :date="dialogDate"
            :height="$vuetify.breakpoint.height * 0.9"
            :subtractHeight="400"
        ></TimeTrackerEvent>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <TimeTrackerConfirmDialog></TimeTrackerConfirmDialog>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEnterEvent from "@/components/TimeTracker/TimeTrackerEnterEvent";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import TimeTrackerEvent from "@/components/TimeTracker/TimeTrackerEvent";
import TimeTrackerNewDialogTime from "@/components/TimeTracker/TimeTrackerNewDialogTime";
import TimeTrackerNewDialogRange from "@/components/TimeTracker/TimeTrackerNewDialogRange";
import TimeTrackerConfirmDialog from "@/components/TimeTracker/TimeTrackerConfirmDialog";


export default {
  name: 'TimeTrackerCalendarEvent',
  props: {
    subtractHeight: {type: [Number], default: 120},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    dto_model: {type: [String], default: 'CalendarDateUserTrackerDTO'}
  },

  components: {
    TimeTrackerEnterEvent,
    BaseDeleteDialog,
    TimeTrackerEvent,
    TimeTrackerNewDialogTime,
    TimeTrackerNewDialogRange,
    TimeTrackerConfirmDialog,
  },

  computed: {
    ...mapGetters('CalendarDateUser', ['getColumns']),
    ...mapFields('CalendarDateUser', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
    getDateEvents() {
      let result = {}
      this.itemList.forEach(function (row) {
        let error_count = row.error_count
        if (row.calendar_date != null)
        result[row.calendar_date.dt] = {
          events: row.event_type_array,
          error_count: error_count,
          error: row.error,
          work: row.work,
          pause: row.pause,
          max_possible: row.max_possible,
          public_holiday: row.calendar_date.public_holiday,
        }
      })
      console.log('getDateEvents', result)
      return result
    },
  },

  watch: {
    dialog: function (newValue, oldValue) {
      // console.log('dialog', newValue, oldValue)
      if (newValue === false) {
        this.dialogDate = null
        this.onUpdateFilters({start: this.last_start, end: this.last_end})
      }
    },
  },

  methods: {
    ...mapActions('CalendarDateUser', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem',]),

    clickOnDate(event) {
      // console.log('clickOnDate', event)
      this.dialogDate = event.date
      this.dialog = true
    },

    onResize() {
      // this.windowHeight = (window.innerHeight - this.subheight) + 'px'
      // console.log(this.$refs)
      let topHeight = 10
      if (this.$refs.RefListTop)
        topHeight = this.$refs.RefListTop.$el.clientHeight
      let footerHeight = 10
      if (this.$refs.RefListFooter)
        footerHeight = this.$refs.RefListFooter.clientHeight
      this.windowHeight = (window.innerHeight - this.subtractHeight - topHeight - footerHeight) + "px"
      // console.log('this.windowHeight', this.windowHeight)
    },

    onUpdateFilters({start, end}) {
      // console.log('onUpdateFilters', this.userId, this.filterEvents, start, end)
      this.title = this.$refs.calendar.title
      this.last_start = start
      this.last_end = end
      if (this.userId !== null)
        this.filters = {user_id: this.userId}
      else
        this.filters = {}
      if (this.filterEvents.length !== 0)
        this.filters['events'] = this.filterEvents
      const min_date = start.date
      const max_date = end.date
      this.filters['from_date'] = min_date
      this.filters['to_date'] = max_date
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFiltersDefault() {
      this.onUpdateFilters({start: this.last_start, end: this.last_end})
    },

    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },

    getDateDark(dateString) {
      let current_datetime = new Date()
      let current_date = current_datetime.setHours(0, 0, 0, 0)

      let date = new Date(dateString)
      date = date.setHours(0, 0, 0, 0)
      // console.log('getDateDark', dateString, current_date, date)
      return current_date === date
    },

    getDateColor(date) {
      if (date in this.getDateEvents && this.getDateEvents[date].public_holiday != null)
        return "green lighten-5"
      if (date in this.getDateEvents && this.getDateEvents[date].error)
        return "red lighten-5"
      if (date in this.getDateEvents && this.getDateEvents[date].max_possible > 0)
        return "blue-grey lighten-5"
      return "grey lighten-5"
    },
    getEventClass(event_name) {
      // console.log('getEventClass', event_name, this.local_phrase)
      return "material-icons material-icon-size " + this.local_phrase[event_name].class
    },
    getEventClassName(event_name) {
      // console.log('getEventClassName', event_name)
      return this.local_phrase[event_name].class
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    getDuration(duration_hours) {
      let abs_duration_hours = Math.abs(duration_hours)
      let hours = Math.floor(abs_duration_hours)
      let minutes = Math.floor(abs_duration_hours * 60) % 60
      if (!duration_hours)
        return '00:00'
      if (duration_hours >= 0)
        return ' ' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
      else
        return '-' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
    this.onResize()
    this.searchTerm = null
    this.$refs.calendar.checkChange()
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
  },

  data() {
    return {
      windowHeight: (this.height - this.subheight) + 'px',
      filterEvents: [],

      dialog: false,
      dialogDate: null,

      title: null,

      focus: '',
      type: 'month',
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      last_start: null,
      last_end: null,
    }
  }
}
</script>

<style scoped lang="scss">
.v-calendar-weekly__day-label {
  margin-bottom: 0;
  margin-top: 0;
}

.scroll {
  overflow-y: scroll
}

.material-icon-size {
  font-size: 36px;
}

.sick, .child_care {
  color: #FFB300;
}

.healing {
  color: #FB8C00;
}

.home, .beach_access {
  color: #43A047;
}
.timer, .more_time
 {
  color: #1E88E5;
}
.work_outline, .access_time
 {
  color: #5E35B1;
}
.pause_circle
 {
  color: #E53935;
}
.timer_off {
  color: #6D4C41
}

.add_alarm
 {
  color: #64B5F6;
}

</style>
